/*
*
* Home actions
*
*/

import {
  USER_DATA,
  USER_TOKEN,
  ORGANIZATIONS_DATA,
  ORGANIZATIONS_DATA_ADD,
  ORGANIZATIONS_FETCHED,
  USER_FETCHED,
  CURRENT_ORAGNIZATION_DATA,
  CONSOLE_LOG,
  SET_UNAUTHORIZED,
  SET_IS_LOADED,
  SET_SMALL_MAIN_NAV,
  SET_HAS_ALL_ORGANIZATIONS,
  SET_REINTALIZE
} from './constants';

export function setReinitializeApp(value) {
  return {
    type: SET_REINTALIZE,
    value,
  };
}


export function setSmallNavMain(value) {
  return {
    type: SET_SMALL_MAIN_NAV,
    value,
  };
}


export function setOrganizationCount(value) {
  return {
    type: SET_HAS_ALL_ORGANIZATIONS,
    value,
  };
}


export function setUserFetched(value) {
  return {
    type: USER_FETCHED,
    value,
  };
}



export function setIsLoaded(value) {
  return {
    type: SET_IS_LOADED,
    value,
  };
}



export function setCurrentOrganization(payload) {
  return {
    type: CURRENT_ORAGNIZATION_DATA,
    payload,
  };
}

export function setUserToken(payload) {
  return {
    type: USER_TOKEN,
    payload,
  };
}


export function setUserData(payload) {
  return {
    type: USER_DATA,
    payload,
  };
}

export function setUnautorized(payload) {
  return {
    type: SET_UNAUTHORIZED,
    payload,
  };
}


export function addOrganizationsData(value) {
  return {
    type: ORGANIZATIONS_DATA_ADD,
    value,
  };
}

export function setOrganizationsData(payload) {
  return {
    type: ORGANIZATIONS_DATA,
    payload,
  };
}

export function setOrganizationsFetched(value) {
  return {
    type: ORGANIZATIONS_FETCHED,
    value,
  };
}

export function consoleLog(payload) {
  return {
    type: CONSOLE_LOG,
    payload,
  };
}
